import { CssBaseline, TextField, Button, Box, Typography } from "@mui/material";

import Navbar from "../../redesign/components/Navbar";
import Footer from "../../redesign/components/Footer";
import { useSelector } from "react-redux";
import { useState } from "react";
import { submitSupportMessage } from "../../services/supportService";
import ReCAPTCHA from "react-google-recaptcha";
const SupportPage = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [ticketId, setTicketId] = useState("");
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await submitSupportMessage(formData);
      setTicketId(data.ticketId); // ticketId from backend
      setStatus("success");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Submission error:", error);
      setStatus("error");
      setTicketId("");
    }
  };
const onchange=() =>{
  
}
  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />
      <div className="support-page_body">
        <div className="frontend-container" style={{ paddingBottom: "50px" }}>
          <Box sx={{ maxWidth: 500, mx: "auto", mt: 4 }}>
            <Typography variant="h5" gutterBottom>
              Contact Support
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                label="Name"
                name="name"
                fullWidth
                margin="normal"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                margin="normal"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <TextField
                label="Message"
                name="message"
                multiline
                rows={4}
                fullWidth
                margin="normal"
                value={formData.message}
                onChange={handleChange}
                required
              />
                <ReCAPTCHA
    sitekey="6LfUpXArAAAAAFzHGENj6esPvFw7J_ugv2DY4V4y"
    onChange={onchange}
         required
  />,
              <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: "var(--primary-blue-color)",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "var(--primary-blue-color)",
                      opacity: 0.8,
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
              {status === "success" && ticketId && (
                <Typography color="green" mt={2}>
                  ✅ Message sent! Your Ticket ID is <strong>{ticketId}</strong>
                  .
                </Typography>
              )}
              {status === "error" && (
                <Typography color="red" mt={2}>
                  ❌ Failed to send. Please try again later.
                </Typography>
              )}
            </form>
          </Box>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SupportPage;
